import { render, staticRenderFns } from "./ProtectionLevel.vue?vue&type=template&id=89129406&"
import script from "./ProtectionLevel.vue?vue&type=script&lang=js&"
export * from "./ProtectionLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports